import React, { useEffect, useRef } from 'react';
import MarkdownRenderer from '../common/MarkdownRenderer';
import './github-markdown-light.css';

const MarkdownPreview = ({ content, onScroll, scrollSync, previewRef }) => {
  return (
    <div
      className='markdown-body'
      style={{
        height: '100%',
        overflowY: 'auto',
        overflowX: 'hidden',
        padding: '20px',
        backgroundColor: '#ffffff',
      }}
      ref={previewRef}
      onScroll={onScroll}
    >
      <MarkdownRenderer content={content} />
    </div>
  );
};

export default MarkdownPreview;

